import React, { FC } from 'react';
import moment from 'moment';
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { printTicketId } from '../../../../../../../../utils/utilMajorEntity';
import TableCell from '../../../../../../../../components/TableCell';
import clsx from 'clsx';
import { createUseStyles } from '../../../../../../../../theming';

const linkToTicket = '/dashboard/ticket/';

interface Props {
  tickets: any;
  loading: boolean;
  hidden: boolean;
}

const useStyles = createUseStyles({
  inProgress: {
    borderLeft: '4px solid #f57c73',
  },
  toProcess: {
    borderLeft: '4px solid #5b4c91',
  },
});

const ArchivedTable: FC<Props> = ({ loading, tickets, ...props }) => {
  const classes = useStyles();

  return (
    <div {...props}>
      {!loading && tickets && (
        <>
          <Table {...props}>
            <TableHead>
              <TableRow>
                <TableCell>Sujet</TableCell>
                <TableCell>Date ouverture</TableCell>
                <TableCell>Date fermeture</TableCell>
                <TableCell>Support</TableCell>
                <TableCell>Responsabilité</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets
                .sort((a, b) => {
                  const aDate = new Date(a.dateCreate);
                  const bDate = new Date(b.dateCreate);
                  return bDate.valueOf() - aDate.valueOf();
                })
                .map((ticket) => {
                  const toProcess = !ticket.closed && ticket.state === 1;
                  const inProgress = !ticket.closed && ticket.state !== 1;

                  return (
                    <TableRow
                      key={ticket.id}
                      className={clsx({ [classes.toProcess]: toProcess, [classes.inProgress]: inProgress })}
                    >
                      <TableCell>
                        <Link to={linkToTicket + ticket.id}>
                          <span>{printTicketId(ticket.id) + ticket.subject} </span>
                        </Link>
                      </TableCell>

                      <TableCell>{moment(ticket.dateCreate).format('DD-MM-YY')}</TableCell>

                      <TableCell>{ticket.closingDate ? moment(ticket.closingDate).format('DD-MM-YY') : ''}</TableCell>

                      <TableCell>
                        {ticket.supportEmployee ? (
                          <Link to={`/dashboard/user/${ticket.supportEmployee.user.id}`}>
                            <span>{ticket.supportEmployee.user.username}</span>
                          </Link>
                        ) : (
                          'Non-renseigné'
                        )}
                      </TableCell>

                      <TableCell>
                        {ticket.closedReason ? ticket.closedReason.label : ticket.closed ? 'Inconnue' : ''}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </>
      )}

      {tickets.length === 0 && <span>Aucun ticket pour ce client.</span>}
    </div>
  );
};

export default ArchivedTable;
